import styled from '@emotion/styled';
import { Typography } from 'antd';

export const SContainer = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const SContainer2 = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const SLeft = styled.div<{ hasRight: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  margin-right: 8px;
  ${({ hasRight }): string => hasRight ? 'max-width: 60%;' : ''}
`;

export const SRight = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 40%;
`;

export const SLabel = styled(Typography.Text)`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SDescription = styled(Typography.Text)`
  font-size: 10px;
`;

export const SSecondaryLabel = styled(Typography.Text)`
  text-align: right;
  align-self: center;
`;

export const STop = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SBottom = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;
